import { createPortal } from 'react-dom';
import EnvironmentDetection from '../../../lib/EnvironmentDetection';
import { JSX } from 'react';

type PortalProps = {
  children: JSX.Element;
};

/**
 * SSR compatible Portal.
 * renders a Portal in document.body
 */
export default function Portal({ children }: PortalProps) {
  if (EnvironmentDetection.isBrowser && children) {
    /* document is ok here, only on browser  */
    return createPortal(children, document.body);
  }
  return null;
}
